import actions from "./actions";

export default {
  namespaced: true,
  state: {
    lives: [],
    audios: []
  },
  mutations: {
    setLives(state, lives) {
      state.lives = lives;
    },
    setAudios(state, audios) {
      state.audios = audios;
    }
  },
  actions
};
